import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Filter } from '../../models/filter.model';
import { Lookup } from '../../models/admin-models/lookup.model';

@Injectable({
    providedIn: 'root'
})
export class ProductTypeService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/producttypes/' + id).toPromise();
    }

    gridView() {
        return this.httpClient.get('api/producttypes')
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createProductType(lookup: Lookup) {
        return this.httpClient.post('api/producttypes/create', lookup.data).toPromise();
    }

    editProductType(lookup: Lookup) {
        return this.httpClient.post('api/producttypes/edit', lookup.data).toPromise();
    }

    deleteProductType(ids: Array<Number>) {
        return this.httpClient.post('api/producttypes/delete', ids).toPromise();
    }

}